import { RESET_WARNING } from '../../constants/strings'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const ResetConfirmationModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="" isOpen={isOpen} handleClose={handleClose}>
      <div></div>
      <p className="mb-8 pt-8 font-bold  text-red-600">{RESET_WARNING}</p>

      <button
        className="rounded bg-red-500 py-2 px-4 font-bold text-white hover:bg-blue-700"
        onClick={() => {
          localStorage.clear()
          setTimeout(function () {
            window.location.reload()
          }, 1000)
        }}
      >
        Reset ?
      </button>
    </BaseModal>
  )
}
